





































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import FileSelector from "@/components/common/FileSelector.vue";
import TableValueInput from "@/views/ChoiceSubmitter/ChoiceSubmitterFixedTable.vue";
import ChoiceFactorInput from "@/components/choice-input/ChoiceFactorInput.vue";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";

import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import TableSingleValueInput from "@/views/ChoiceSubmitter/ChoiceSubmitterGrowingTable.vue";
import Viewpoints from "@/store/modules/Viewpoints";
import Modelling from "@/store/modules/Modelling";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import CommentBadge from "@/components/comments/CommentBadge.vue";
import Choices from "@/store/modules/Choices";
import { ResourceType } from "@/store/modules/Comments";

const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions);
@Component({
    name: "ChoiceSubmitterGroupComp",
    components: {
        TableSingleValueInput,
        FactorValueInput: ChoiceFactorInput,
        TableValueInput,
        FileSelector,
        CommentBadge
    },
})
export default class ChoiceSubmitterGroup extends Vue {
    @Prop()
    parentFactorGroup!: string;

    @Prop()
    elements!: string[];

    @Prop()
    choiceForm!: any;

    @Prop({ type: Boolean, default: false })
    checkboxes!: boolean;

    @Prop({type: Boolean, default: false})
    disableInputs!: boolean

    hovers = Array.apply(null, new Array(this.elements.length)).map((f) => false);

    // description
    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get expansionValues() {
        return workspaceOptionsModule.expansions;
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get contributingFactorResources() {
        return viewpointsModule.contributingFactorResources;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get isFactorListActive() {
        console.log(workspaceOptionsModule.activeFactorLists.length > 0)
        return workspaceOptionsModule.activeFactorLists.length > 0
    }

    get commentsVisibility() {
        return workspaceOptionsModule.commentsVisibility
    }

    get resource() {
        return {
            id: 'Choice',
            name: `${this.selectedDecision.name}`,
            type: ResourceType.CHOICE
        }
    }

    get secondaryResource() {
        if (getModule(Choices).choices[this.choiceForm.id]) {
            return {
                id: this.choiceForm.id,
                type: ResourceType.CHOICE,
                name: getModule(Choices).choices[this.choiceForm.id].name
            }
        }
    }

    get editContent() {
        return workspaceOptionsModule.editContent;
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    private startingFactors(resourceId: string) {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = resourceId
            return this.getTopGroup(resourceId)
        
        } else {
            return this.factors[resourceId].childrenIds
        }
        
    }

    private getTopGroup(topId: string) {
        if(this.factors[topId].childrenIds && this.factors[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factors[this.factors[topId].childrenIds[0]] || this.factors[this.factors[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return this.factors[topId].childrenIds
        }

        if(this.factors[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factors[topId].childrenIds[0])
        }
        
    }

    private isFactorVisible(resourceId: string) {
        //If no factor list filtering
        if(this.showNonListFactors || !this.isFactorListActive) {
        //    return  this.contributingVisibility || (!this.contributingVisibility && this.contributingFactorResources[resourceId])
            return true;
        }
        else {
            if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
            } else
                return false;
        }
    }

    get isViewpointActive() {
        return (viewpointsModule.activeViewpointId != null)
    }

    // description
    private getDescriptionVisibility() {
        return this.descriptionVisibility;
    }

    isAllFilled(groupId: string) {
        let factorGroup = this.factors[groupId] as FactorGroup;
        let subFactorGroups = (factorGroup.childrenIds || [])
            .map((id) => this.factors[id])
            .filter((tg) => tg && tg.type !== "FACTOR");
        if (subFactorGroups.length > 0) {
            let subFactorGroupsNotFilled = subFactorGroups
                .map((tg) => this.isAllFilled(tg.id))
                .filter((filled) => !filled);
            if (subFactorGroupsNotFilled.length > 0) {
                return false;
            }
        }

        let factors = (factorGroup.childrenIds || [])
            .map((id) => this.factors[id])
            .filter((tg) => tg && tg.type === "FACTOR");
        if (factors.length === 0) {
            return true;
        }

        //@ts-ignore
        return (
            factors.map((f) => this.choiceForm[(f as Factor).dataField]).filter((c) => !c)
                .length === 0
        );
    }
}
